import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../firebase/config";

export const isAdmin = async () => {
  const uid = auth.currentUser?.uid;

  if (!uid) return false;

  const snapshot = await getDoc(doc(db, "admins", uid));

  return snapshot.exists();
};
